import { useMemo } from 'react';
import timezoneLookup from 'tz-lookup';
import { useLocation } from '@/data/sources/location';
import { COLOR, HOME } from './constants';
import type { GeoNode } from './types';

const ME_FALLBACK: GeoNode = {
  city: HOME.city,
  lat: HOME.lat,
  lon: HOME.lon,
  color: COLOR.accent,
};

export const useMe = (): { me: GeoNode; tz: string } => {
  const { data: location } = useLocation();

  return useMemo(() => {
    const lat = location?.latitude;
    const lon = location?.longitude;

    if (lat == null || lon == null) {
      return { me: ME_FALLBACK, tz: HOME.tz };
    }

    let tz = HOME.tz;
    try {
      tz = timezoneLookup(lat, lon);
    } catch {}

    return {
      me: {
        city: location?.city ?? ME_FALLBACK.city,
        lat,
        lon,
        color: COLOR.accent,
      },
      tz,
    };
  }, [location?.latitude, location?.longitude, location?.city]);
};
